import "./Settings.scss";
import { useTheme } from "../../context/themeContext";

function Settings({ setIsOpen, setIsRendering }) {
    const {isDarkMode, toggleTheme} = useTheme();

    return (
        <div className="settings-wrapper">
            <div className="settings-content">
                <div className="settings-block">
                    <div className="settings-dark-theme">
                        <div className="text">Тёмная тема</div>
                        <div className="buttons">
                            <div className={"button " + (!isDarkMode ? "on" : "")} onClick={isDarkMode ? toggleTheme : () => {}}>Выкл</div>
                            <div className={"button " + (isDarkMode ? "on" : "")} onClick={!isDarkMode ? toggleTheme : () => {}}>Вкл</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;